<template lang="html">
  <span>
    <v-icon v-if="_.get(company, 'accountStatus.disabledSince', false)" color="accent">report</v-icon>
    <v-icon v-else-if="_.get(company, 'accountStatus.verified', false)" color="green">verified_user</v-icon>
    <span> {{company.displayName}}</span>
  </span>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'CompanyName',
  props: {
    company: Object,
  },
  computed: {
    _() {
      return _;
    },
  },
}
</script>

<style lang="css" scoped>
span{
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CompanyName.vue